import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const PageLayout = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className={`flex-1 ${className}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};
